module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\" id=\"modal-title\">内容</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n    <p>\n        {{content}}\n    </p>\n</div>\n<div class=\"modal-footer\">\n    <button class=\"btn btn-warning\" type=\"button\" ng-click=\"cancel(1)\">关闭</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/new/modal/add.html
// module id = 270
// module chunks = 0